import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import { PriceType } from "@/v2/enums/PriceType";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EditPriceModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    initialPricingType: {
      type: String,
      default: PriceType.FIXED,
    },
    initialValue: {
      type: [String, Number],
      default: "",
    },
  },
  emits: ["close", "save"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  const priceType = ref(props.initialPricingType);
  const priceValue = ref(props.initialValue?.toString() || "");

  const showPriceValue = computed(() => {
    return (
      priceType.value === PriceType.FIXED || priceType.value === PriceType.FROM
    );
  });

  const isFormValid = computed(() => {
    if (showPriceValue.value) {
      return priceValue.value && priceValue.value.trim() !== "";
    }

    return true;
  });

  watch(
    () => props.isOpen,
    (newIsOpen) => {
      if (newIsOpen) {
        priceType.value = props.initialPricingType;
        priceValue.value = props.initialValue?.toString() || "";
      }
    }
  );

  const formatPrice = (event: Event) => {
    const target = event.target as HTMLInputElement;
    let value = target.value.replace(/[^\d]/g, "");

    if (value) {
      value = parseInt(value).toLocaleString();
    }

    priceValue.value = value;
    target.value = value;
  };

  function close() {
    emits("close");
  }

  function save() {
    const priceData = {
      type: priceType.value,
      value:
        priceType.value === PriceType.FIXED ||
        priceType.value === PriceType.FROM
          ? priceValue.value.replace(/,/g, "")
          : null,
    };

    emits("save", priceData);
    close();
  }

const __returned__ = { emits, props, priceType, priceValue, showPriceValue, isFormValid, formatPrice, close, save, ref, computed, watch, Modal, get PriceType() { return PriceType } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})